import { createReducer, on } from '@ngrx/store';
import { AddMessage, ClearStore, RemoveMessage } from '../actions/message.actions';
import { AppState } from '../states/app.state';

export const initialState: AppState = {
  userEvents: [],
};

export const signalrReducer = createReducer(
  initialState,
  on(AddMessage, (state, { payload }) => ({ userEvents: state.userEvents.concat(payload) })),
  on(RemoveMessage, (state, { payload }) => ({
    userEvents: state.userEvents.filter(
      x => x.correlationId == payload.correlationId && x.eventType == payload.eventType
    ),
  })),
  on(ClearStore => ({ userEvents: [] }))
);
